import React from 'react'
import { buildQuestionOptionList, getActiveQuestionOptions } from './questionOptionHierarchy'
import './QuestionChildOptionPills.css'

const QuestionChildOptionPills = ({ question, onToggle }) => {
  const choices = buildQuestionOptionList(question.options)
  const active = getActiveQuestionOptions(question, choices)
  const selectedKeys = new Set(active.map(choice => choice.selectionKey))

  const renderChildren = (parent) => {
    const children = choices.filter(choice => choice.parentSelectionKey === parent.selectionKey)
    if (!children.length) return null
    return (
      <div key={parent.selectionKey} className="mt-2 border-start ps-3" role="group" aria-label={`Options for ${parent.label}`}>
        <div className="small mb-2">{parent.label}</div>
        <div className="d-flex flex-wrap gap-2">
          {children.map(child => {
            const selected = selectedKeys.has(child.selectionKey)
            return (
              <button
                key={child.selectionKey}
                type="button"
                className={`question-child-option-pill btn btn-sm rounded-pill ${selected ? 'btn-primary' : 'btn-outline-primary'}`}
                aria-pressed={selected}
                onClick={() => onToggle(child.selectionKey)}
                style={{ whiteSpace: 'normal', overflowWrap: 'anywhere', textAlign: 'left' }}
              >
                {child.label}
              </button>
            )
          })}
        </div>
        {children.filter(child => selectedKeys.has(child.selectionKey)).map(renderChildren)}
      </div>
    )
  }

  return <>{active.filter(choice => choice.depth === 0).map(renderChildren)}</>
}

export default QuestionChildOptionPills
